module.exports = __webpack_public_path__ + "static/media/sixinarow-iphone5s-bezel-add-events.c4184a66.png";